/**
 * Dropdown used in admin.
 */
const dropdowns = [];
function closeDropdowns() {
  dropdowns.forEach((dropdown) => {
    dropdown.classList.add("hidden");
  });
}

document.addEventListener("DOMContentLoaded", () => {
  document.body.addEventListener("click", closeDropdowns);
});

export default function initDropdown(trigger) {
  const dropdown = trigger.nextElementSibling;
  dropdowns.push(dropdown);
  trigger.addEventListener("click", () => {
    setTimeout(() => {
      if (dropdown.classList.contains("hidden")) {
        dropdown.classList.remove("hidden");
      } else {
        dropdown.classList.add("block");
      }
    }, 100);
  });
}
